export default "__VITE_ASSET__vbd2bRzp__"